// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shopify-dashboard-with-data {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.shopify-dashboard-with-data > * {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/dashboards/shopify/pages/ShopifyDashboard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AACF","sourcesContent":[".shopify-dashboard-with-data {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.shopify-dashboard-with-data > * {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
